import React from 'react';
import { QuintaAuthProvider, useQuintaAuth } from '../../context/QuintaAuthContext';
import { CommunityLanding } from '../community/CommunityLanding';
import { CommunityDashboard } from '../community/CommunityDashboard';
import { COMMUNITY_BRANDS } from '../community/communityBrands';

const brand = COMMUNITY_BRANDS.quinta;

const QuintaPageInner = () => {
  const { member, loading } = useQuintaAuth();

  if (loading) {
    return (
      <div className="min-h-screen w-full bg-[#0E4D2A] flex items-center justify-center text-[#A8B4A6] font-sans tracking-widest text-sm">
        ...
      </div>
    );
  }

  return member ? (
    <CommunityDashboard brand={brand} useAuth={useQuintaAuth} forumPath="/quinta/forum" />
  ) : (
    <CommunityLanding brand={brand} useAuth={useQuintaAuth} />
  );
};

export const QuintaPage = () => (
  <QuintaAuthProvider>
    <QuintaPageInner />
  </QuintaAuthProvider>
);

export default QuintaPage;
